







































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import addSite from '@/components/add business objects/addSite.vue';
import OrgSuggest from '@/components/form pickers/orgSuggest.vue';

@Component({
	components: {
		OrgSuggest,
		addSite,
		secondaryNav,
		vSelect,
	},
})
export default class SiteCreate extends Vue {
	public org = { name: '', sites: [] };
	public site: any = {
		id: undefined,
		orgId: undefined,
		name: '',
		address: { fullAdr: '', region: '', location: '' },
	};
	public load() {
		this.$router.push({ name: 'sites.view', params: { siteId: this.site.id } });
	}
}
